<template>
    <v-btn color="primary" @click="printReceipt" prepend-icon="mdi-printer">
        Надрукувати чек
    </v-btn>
</template>

<script setup>
import {useAuthStore} from "../stores/authStore.js";

const props = defineProps(['orderData']);
const authStore = useAuthStore();

const printReceipt = () => {
    const win = window.open('', 'PRINT', 'height=600,width=400');

    const date = new Intl.DateTimeFormat("uk-UA", {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit'
    }).format(new Date(props.orderData.created_at));

    const totalSum = props.orderData.sum.toFixed(2);
    const discount = props.orderData.sum_discount.toFixed(2);
    const totalWithDiscountSum = (props.orderData.sum + props.orderData.sum_discount).toFixed(2);

    const payments = props.orderData.pays.map(pay =>
        `${pay.method.name}: ${pay.sum.toFixed(2)} грн`
    ).join('<br>');

    const prePayments = props.orderData?.pre_pays?.map(pay =>
        `${pay.method.name}: ${pay.sum.toFixed(2)} грн`
    ).join('<br>') || '';

    let preorder = '';
    let paidDeposit = '';

    if (props.orderData?.type?.code === 'pre-order') {
        const preorderPaysSum = props.orderData.pays.reduce((sum, pay) => sum + pay.sum, 0);
        preorder = `<div>Передоплата</div>`;
        if ((Number(totalSum) - preorderPaysSum) > 0) {
            paidDeposit = `<div>Залишок до сплати: ${(Number(totalSum) - preorderPaysSum).toFixed(2)} грн</div>`;
        }
    }

    const productLines = props.orderData.products.map(orderProduct => {
        const product = orderProduct.product;
        const line1 = `${product.name},${product.brand.name} (${product.color.name}, ${product.size.name})`;
        const line2 = `${orderProduct.qty} x ${orderProduct.price.toFixed(2)} грн = ${(orderProduct.qty * orderProduct.price).toFixed(2)} грн`;

        const discountAmount = (orderProduct.sum - orderProduct.sumFinal).toFixed(2);

        let discountLine = '';
        if (orderProduct.sumFinal < orderProduct.sum) {
            discountLine = `- Знижка: ${discountAmount} грн<br>`;
        }

        const line3 = `= ${orderProduct.sumFinal.toFixed(2)} грн`;

        return `
            ${line1}<br>
            ${line2}<br>
            ${discountLine}
            ${line3}<br>
            ---------------------------<br>
        `;
    }).join('');

    const printTemplate = `
    <html>
      <head>
        <title>Касовий чек</title>
        <style>
          @media print {
            body { margin: 0; }
          }
          body {
            width: 58mm;
            font-family: monospace;
            font-size: 12px;
            color: black;
            padding: 5px;
          }
          .center {
            text-align: center;
          }
          .separator {
            border-top: 1px dashed black;
            margin: 5px 0;
          }
          .bold {
            font-weight: bold;
          }
          .mb-5 {
            margin-bottom: 5px;
          }
        </style>
      </head>
      <body>
        <div class="center bold">
          ${authStore.user.shop.name}<br>
          ---------------------------<br>
          ТОВАРНИЙ ЧЕК № ${props.orderData.numberCheck}<br>
          ${date}<br>
        </div>

        <div class="mb-5">
           Зміна: ${authStore.user.name}<br>
          ${authStore.user.shop.details || ''}<br>
          ${authStore.user.shop.address || ''}
        </div>

        <div class="separator"></div>

        ${productLines}

        <div class="separator"></div>
        <div>
          Сума: ${totalWithDiscountSum} грн<br>
          ${preorder ? preorder + '<br>' : ''}
          ${prePayments ? '<br>Передоплата:<br>' + prePayments + '<br>' : ''}
          Оплата:<br>
          ${payments}<br>
          ${paidDeposit ? paidDeposit + '<br>' : ''}
          ${props.orderData.sum_discount > 0 ? 'Знижка: ' + discount + ' грн<br>' : ''}
          <span class="bold">Всього до сплати: ${totalSum} грн</span><br>
        </div>

        <div class="separator"></div>

        <div class="center">
          Дякуємо за покупку!
        </div>
      <div style="height: 70px"></div>

      </body>
    </html>
  `;

    win.document.write(printTemplate);
    win.document.close();
    win.focus();
    win.print();
    win.close();
};
</script>

<style scoped>
</style>
